import React, { useEffect, useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Card from "components/card";
import Box from "@mui/material/Box";
import axios from "../../../../api/axios";
import ComplaintDetailsModal from "./ComplaintDetailsModalPolice.jsx";

const ComplaintsTable = ({ tableData }) => {
  const [rows, setRows] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [loading, setLoading] = useState(true);

  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedComplaintDescription, setSelectedComplaintDescription] = useState("");
  const [selectedComplaintStatus, setSelectedComplaintStatus] = useState(null);

  const fetchReportDetails = async (reportId, complaintId, policeStatus) => {
    const token = "Bearer " + localStorage.getItem("token")?.replace(/"/g, "");
    try {
      const response = await axios.get(`/api/reports/report/${reportId}`, {
        headers: { Authorization: token, "Content-Type": "application/json" },
      });

      const reportWithComplaintId = { ...response.data, complaintId };
      setSelectedReport(reportWithComplaintId);
      setSelectedComplaintDescription(response.data.description);
      setSelectedComplaintStatus(policeStatus);
    } catch (err) {
      console.error("Gabim gjatë marrjes së detajeve të raportit", err);
    }
  };

  useEffect(() => {
    setRows(tableData);
    setLoading(false);
  }, [tableData]);

  const columns = useMemo(
    () => [
      { field: "reportName", headerName: "Emri i raportit", flex: 1, minWidth: 180, align: "center", headerAlign: "center" },
      {
        field: "reportDate",
        headerName: "Data e raportit",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        valueFormatter: ({ value }) => new Date(value).toLocaleDateString("sq-AL"),
      },
      { field: "category", headerName: "Kategoria", flex: 1, minWidth: 150, align: "center", headerAlign: "center" },
      {
        field: "createdAt",
        headerName: "Data e ankesës",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        valueFormatter: ({ value }) => new Date(value).toLocaleDateString("sq-AL"),
      },
      {
        field: "policeStatus",
        headerName: "Statusi",
        flex: 1,
        minWidth: 140,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          const statusMap = { 0: "Në pritje", 1: "Aprovuar", 2: "Refuzuar" };
          const label = statusMap[params.value] ?? "I panjohur";
          const cls =
            label === "Aprovuar"
              ? "bg-green-100 text-green-800"
              : label === "Refuzuar"
              ? "bg-red-100 text-red-800"
              : "bg-yellow-100 text-yellow-800";
          return <span className={`rounded px-2 py-1 text-xs font-semibold ${cls}`}>{label}</span>;
        },
      },
      {
        field: "details",
        headerName: "Detajet",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <label
            htmlFor="my-modal-5"
            className="rounded-xl bg-brand-500 px-[15px] py-[8px] text-base font-medium text-white transition duration-200 hover:bg-brand-700 active:bg-brand-800 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            onClick={() => {
              fetchReportDetails(params.row.reportId, params.row.id, params.row.policeStatus);
            }}
          >
            Shiko
          </label>
        ),
      },
    ],
    []
  );

  return (
    <>
      {/* Filtër */}
      <div className="mb-4 flex flex-wrap gap-4">
        <input
          type="text"
          placeholder="Kërko sipas përdoruesit"
          value={searchUser}
          onChange={(e) => setSearchUser(e.target.value)}
          className="w-full rounded border border-gray-300 px-3 py-2 sm:w-[250px]"
        />
        <input
          type="date"
          value={searchDate}
          onChange={(e) => setSearchDate(e.target.value)}
          className="w-full rounded border border-gray-300 px-3 py-2 sm:w-[200px]"
        />
        <button className="rounded bg-brand-500 px-4 py-2 text-white hover:bg-brand-700">Kërko</button>
      </div>

      {/* Modal */}
      <ComplaintDetailsModal
        selectedReport={selectedReport}
        complaintDescription={selectedComplaintDescription}
        complaintStatus={selectedComplaintStatus}
        adminName={localStorage.getItem("name")} 
        onActionCompleted={(complaintId, newStatus) => {
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.id === complaintId ? { ...row, policeStatus: newStatus } : row
            )
          );
        }}
      />

      {/* Tabela */}
      <Card extra={"w-full sm:overflow-auto p-4"}>
        <Box>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            autoHeight
            pageSize={10}
            rowsPerPageOptions={[10]}
            loading={loading}
            disableColumnMenu
            disableSelectionOnClick
            localeText={{
              noRowsLabel: "Nuk u gjetën ankesa",
              footerRowSelected: (count) =>
                count !== 1
                  ? `${count.toLocaleString()} rreshta të zgjedhur`
                  : `${count.toLocaleString()} rresht i zgjedhur`,
              footerTotalRows: "Gjithsej rreshta:",
              MuiTablePagination: {
                labelRowsPerPage: "Rreshta për faqe:",
              },
            }}
            className="text-black dark:text-white"
          />
        </Box>
      </Card>
    </>
  );
};

export default ComplaintsTable;
